export function ValidPhoneNumberDirective() {
    'ngInject';

    let data = {};
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, $element, $attrs, $model) {
            Object.assign(data, {
                $scope, $element, $attrs, $model
            });

            $scope.$watch(
                () => $model.$modelValue,
                newValue => {
                    _validate(newValue);
                }
            );
        }
    };

    function _validate(newValue) {
        const isFirstNumberValid = (/^[2-9]/).test(newValue);
        data.$model.$setValidity('firstNumberError', isFirstNumberValid);
    }
}
